import PrimarySearchIcon from "@/User/Assets/Svgs/SearchPrimaryIcon.svg";
import PrimaryButton from "@/User/Components/Buttons/PrimaryButton";
import { usePage } from "@inertiajs/react";
import { map, reduce } from "lodash";
import React from 'react';
import route from 'ziggy-js';

const ConditionTagSearch = () => {
    const {
        filteredIndustryIds,
        industryCodeList,
        filteredBudgetList,
        budgetList,
        filteredThemeList,
        themeList
    } = usePage().props;

    const industryList = reduce(industryCodeList, (result, item, idx) => {
        return [
            ...result,
            ...map(item, (it, itdx) => {
                return {
                    id: parseInt(itdx),
                    name: it,
                    cate_id: idx,
                };
            }),
        ];
    }, []);

    const transformedIndustryList = industryList.filter((item) => filteredIndustryIds.includes(item.id));

    const transformedBudgets = reduce(budgetList, (result, item, idx) => {
        return [
            ...result,
            {
                id: parseInt(idx),
                ...item,
            }
        ];
    }, []).filter((item) => filteredBudgetList.includes(item.id));

    const transformedThemeList = reduce(themeList, (result, item, idx) => {
        return [
            ...result,
            {
                id: parseInt(idx),
                name: item,
            },
        ];
    }, []).filter((item) => filteredThemeList.includes(item.id));

    return (transformedIndustryList.lenghth > 0
        || transformedBudgets.length > 0
        || transformedThemeList.length > 0
    ) && (
        <section id="condition-tag-search" className="container pt-5 pb-6 md:pb-10 lg:py-10">
            <div className="text-center text-primary">
                <div className="flex justify-center items-center mb-2.5">
                    <img src={PrimarySearchIcon} alt="新着案件から探す" className="size-6"/>
                </div>
                <h2 className="leading-tight">条件から探す</h2>
            </div>

            {transformedIndustryList.length > 0 && (
                <div id="business-tags" className="py-4">
                    <h3 className="px-2.5 py-1.5 mb-4 bg-zircon font-light text-base leading-tight">業種から探す</h3>
                    <div className="flex flex-wrap gap-x-1.25 gap-y-2">
                        {transformedIndustryList.map((item) => (
                            <PrimaryButton as="link" href={route('business_page', { id: item.id })}
                                isOutline={true} isRounded={true}
                                className="!py-2.5 lg:!py-2.5 lg:!px-4"
                                key={`business-${item.id}`}
                            >
                                {item.name}
                            </PrimaryButton>
                        ))}
                    </div>
                </div>
            )}

            {transformedBudgets.length > 0 && (
                <div id="budget-tags" className="py-4">
                    <h3 className="px-2.5 py-1.5 mb-4 bg-zircon font-light text-base leading-tight">予算から探す</h3>

                    <div className="flex flex-wrap gap-x-1.25 gap-y-2">
                        {transformedBudgets.map((item) => (
                            <PrimaryButton as="link" href={route('budget_page', { id: item.id })}
                                isOutline={true} isRounded={true}
                                className="!py-2.5 lg:!py-2.5 lg:!px-4"
                                key={`budget-${item.id}`}
                            >
                                {item.label}
                            </PrimaryButton>
                        ))}
                    </div>
                </div>
            )}

            {transformedThemeList.length > 0 && (
                <div id="theme-tags" className="py-4">
                    <h3 className="px-2.5 py-1.5 mb-4 bg-zircon font-light text-base leading-tight">テーマから探す</h3>

                    <div className="flex flex-wrap gap-x-1.25 gap-y-2">
                        {transformedThemeList.map((item) => (
                            <PrimaryButton as="link" href={route('theme_page', { id: item.id })}
                                isOutline={true} isRounded={true}
                                className="!py-2.5 lg:!py-2.5 lg:!px-4"
                                key={`theme-${item.id}`}
                            >
                                {item.name}
                            </PrimaryButton>
                        ))}
                    </div>
                </div>
            )}
        </section>
    );
};

export default ConditionTagSearch;
